export type ServiceIconType = "rocket" | "cogs" | "store";

export interface ServiceData {
  id: string;
  name: string;
  subtitle: string;
  navDescription: string;
  description: string;
  features: string[];
  link: string;
  color: "gold" | "pink" | "purple";
  goldText: string;
  pinkText: string;
  icon: ServiceIconType;
}

export const services: ServiceData[] = [
  {
    id: "flocktank",
    name: "FlockTank",
    subtitle: "Crowdfunding & Growth",
    navDescription: "Crowdfunding & growth for co-ops",
    description:
      "Launch a new co-op, transition your business to employee ownership, or run a growth campaign to scale an existing cooperative. Connect with investors who believe in worker ownership.",
    features: [
      "Launch, transition & growth campaigns",
      "Revenue-based financing (debt-style)",
      "Invest as little as $100",
      "All-or-nothing funding model",
    ],
    link: "/services/flocktank",
    color: "gold",
    goldText: "Flock",
    pinkText: "Tank",
    icon: "rocket",
  },
  {
    id: "flockworker",
    name: "FlockWorker",
    subtitle: "Business Operations",
    navDescription: "Business operations system",
    description:
      "All-in-one operations platform for new and existing worker cooperatives. Governance, HR, forms, training, payroll, accounting, inventory, and analytics — starting at $39/month.",
    features: [
      "8 modules: governance to analytics",
      "Integrated HR, payroll & accounting",
      "Forms, surveys & training built in",
      "Plans from $39/mo + per member",
    ],
    link: "/services/flockworker",
    color: "pink",
    goldText: "Flock",
    pinkText: "Worker",
    icon: "cogs",
  },
  {
    id: "flocklist",
    name: "FlockList",
    subtitle: "Shop Co-Op Online",
    navDescription: "Shop co-op online",
    description:
      "Browse and buy from worker-owned businesses in one easy-to-use marketplace. Bid on service contracts or sell products with real-time inventory sync. Included with Business & Enterprise plans.",
    features: [
      "Included with Business & Enterprise",
      "Real-time inventory from FlockWorker",
      "Bid on co-op service contracts",
      "Free for shoppers to browse & buy",
    ],
    link: "/services/flocklist",
    color: "purple",
    goldText: "Flock",
    pinkText: "List",
    icon: "store",
  },
];

export function getServiceById(id: string): ServiceData | undefined {
  return services.find((s) => s.id === id);
}

export function getServiceByName(name: string): ServiceData | undefined {
  return services.find((s) => s.name === name);
}
